import { render, staticRenderFns } from "./activeEmployeeTable.vue?vue&type=template&id=1cb48e04"
import script from "./activeEmployeeTable.vue?vue&type=script&lang=js"
export * from "./activeEmployeeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports